import { inflate } from 'pako';

/**
 * @function decodeClientData
 *
 * @description
 * Decodes/inflates the window data for client consumption
 *
 * @param  {String} windowClientData Gzipped and base-64 encoded client data
 * @return {Object}                  Unzipped and JSON parsed object
 */
export function decodeClientData(windowClientData) {
    if (_.isString(windowClientData)) {
        return JSON.parse(inflate(atob(windowClientData), { to: 'string' }));
    }
    return _.isObject(windowClientData) ? windowClientData : {};
}
